import React from 'react';
import './PropertyTypes.css';

export default function PropertyTypes() {
  const propertyTypes = [
    { name: 'Hotels', image: '/assets/595549020.jpeg' },
    { name: 'Apartments', image: '/assets/595549146.jpeg' },
    { name: 'Resorts', image: '/assets/595549239.jpeg' },
    { name: 'Villas', image: '/assets/595550229.jpeg' },
    { name: 'Homestays', image: '/assets/595550415.jpeg' },
  ];

  return (
    <section className="block">
      <div className="container">
        <div className="section-head">
          <h2>Browse by property type</h2>
        </div>
        <div className="grid grid-5">
          {propertyTypes.map((type, idx) => (
            <div key={idx} className="ptype-card">
              <div className="imgslot" data-label={type.image}>
                <img src={type.image} alt={type.name} onError={(e) => (e.target.style.display = 'none')} />
              </div>
              <div className="name">{type.name}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
